import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/min/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/min/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/min/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/min/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/min/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/min` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/min?title=${title}` , { headers: authHeader() });
};

const MinService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default MinService;
